exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-logo[data-v-b799b002]{margin-right:.1rem}.btn[data-v-b799b002]{width:2.56rem;height:.56rem;background:linear-gradient(90deg, #225BFC 0%, #1C50DE 100%);border-radius:.04rem;font-size:.18rem;font-family:DMSans-Bold,DMSans;font-weight:bold;color:#fff;text-align:center;margin-top:.64rem;cursor:pointer}", ""]);

// exports
